import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useHistory } from "react-router-dom";
import { Sidebar, Menu, SubMenu, MenuItem } from "react-pro-sidebar";
import { useDispatch, useSelector } from "react-redux";
import { setCollapsed } from "../../Redux/Layout/layoutSlice";
import { admin, sidebarData } from "./SidebarData";
import "./sidebar.css";
import { IoIosArrowDropleftCircle, IoIosArrowDroprightCircle } from "react-icons/io";
import getCookie from "../../Utils/Cookies/getCookie";
import { logout } from "../../Redux/Auth/thunk";
import { errorFunction, successFunction } from "../Alert/Alert";
import { setSystemSelected } from "../../Redux/SystemSelection/systemSelectionSlice";
import logo from "../../assets/sidebar-icon.svg";
import CreateAlert from "../Alert/CreateAlert";

const CrmSidebar = () => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const permissionApi = useSelector((state) => state.auth.permissions);
  const isSuperuser = useSelector((state) => state.auth.isSuperuser);
  const { collapsed, showModal } = useSelector((state) => state.layout);
  const [search, setSearch] = useState("");
  const [toggled, setToggled] = useState(false);
  const [disablePointerEvents, setDisablePointerEvents] = useState(false);
  const collapseicon = useSelector((state) => state.layout.collapseIcon);
  const username = useSelector((state) => state.auth.username);
  const capitalizedUserName = username.charAt(0).toUpperCase() + username.slice(1);
  const photo = useSelector((state) => state.auth.photo);
  const [open, setOpen] = useState();
  const [childMenuOpen, setChildMenuOpen] = useState();
  const [remove, setRemove] = useState(false);
  const [showAlert, setShowAlert] = useState(false);

  const handleOpenSubMenu = (key) => {
    if (open === key) {
      setOpen(undefined);
    } else {
      setOpen(key);
    }
  };

  const handleChildMenuOpen = (key) => {
    if (childMenuOpen === key) {
      setChildMenuOpen(undefined);
    } else {
      setChildMenuOpen(key);
    }
  };

  const handleMenuClick = () => {
    // Disable pointer events
    setDisablePointerEvents(true);
    // Enable pointer events after 750 milliseconds
    setTimeout(() => {
      setDisablePointerEvents(false);
    }, 750);
    // Your existing logic for handling menu click
    // ...userPermissions
  };

  const menuItemStyles = {
    root: {
      fontSize: "14px",
      fontWeight: 400,
      transition: "all 0.25s ease-out",
    },
    icon: {
      margin: "0px",
    },

    SubMenuExpandIcon: {
      color: "#b6b7b9",
    },

    button: ({ level, active, disabled }) => {
      if (level === 0)
        return {
          padding: "0px 10px 0 0 ",
          "&:hover": {
            backgroundColor: "var(--blue-primary)",
            color: "white !important",
            borderRadius: "10px",
            transition: "all 0.25s ease-in",
          },
        };
      if (level === 1)
        return {
          color: "rgba(36, 34, 32, 0.86)",
          height: "max-content",
          "&:hover": {
            backgroundColor: "var(--blue-primary)",
            color: "white !important",
            marginLeft: collapsed ? "0px" : "20px",
            borderRadius: collapsed ? "5px" : "10px",
            transition: "all 0.25s ease-in",
          },
        };
      if (level === 2)
        return {
          color: "rgba(36, 34, 32, 0.56)",
          marginLeft: "10px",
          height: "50px",
          "&:hover": {
            backgroundColor: "var(--blue-primary)",
            color: "white !important",
            marginLeft: collapsed ? "0px" : "20px",
            borderRadius: collapsed ? "5px" : "10px",
            transition: "all 0.25s ease-in",
          },
        };
    },

    label: ({ open, level }) => {
      if (level === 0)
        return {
          padding: "15px",
        };
      if (level === 1)
        return {
          padding: collapsed ? "10px 5px" : " 10px 20px",
          "&:hover": {
            padding: collapsed ? "10px 0px" : "10px 0px",
          },
        };
    },
  };

  const handleLogout = () => {
    if (!remove) {
      setShowAlert(true);
    } else {
      const token = getCookie("refreshToken");
      if (token) {
        dispatch(logout(token))
          .unwrap()
          .then(() => {
            successFunction("Logged out successfully.");
            dispatch(setSystemSelected(""));
            history.push("/");
          })
          .catch((error) => errorFunction("Failed to logout."));
      }
      setShowAlert(false);
      setRemove(false);
    }
  };

  useEffect(() => {
    if (remove) {
      handleLogout();
    }
  }, [remove]);

  useEffect(() => {
    const numberInputs = document.querySelectorAll('input[type="number"]');
    numberInputs.forEach((input) => {
      input.addEventListener("wheel", function (event) {
        event.preventDefault();
      });
    });
  });

  return (
    <>
      <div
        className={collapsed ? "collapsed-sidebar d-flex flex-column" : "sidebar d-flex flex-column"}
        style={{ position: "relative", height: "100vh" }}
      >
        <div className="sidebar-header d-flex justify-content-between align-items-center">
          <Link to="/">
            {collapsed ? (
              <div className="logo-container collapsed">
                <img alt="logo" src={logo} />
              </div>
            ) : (
              <div className="logo-container">
                <p className="m-0">Dege Carpet Pvt. Ltd.</p>
              </div>
            )}
          </Link>
          {collapseicon && (
            <button
              type="button"
              className={"collapse-btn"}
              disabled={showModal}
              onClick={() => {
                dispatch(setCollapsed());
              }}
            >
              {collapsed ? <IoIosArrowDroprightCircle /> : <IoIosArrowDropleftCircle />}
            </button>
          )}
        </div>
        {!collapsed && (
          <Sidebar
            collapsedWidth="45px"
            className="sidebar h-100"
            collapsed={collapsed}
            toggled={toggled}
            breakPoint="md"
            transitionDuration={250}
            rootStyles={{
              overflow: "auto",
              padding: "10px",
              backgroundColor: "white",
              [`.ps-sidebar-container`]: {
                backgroundColor: "white",
              },
            }}
          >
            <div className="d-flex flex-column h-100 justify-content-between ">
              <div>
                {/* <div className={`sidebar-section-title ${collapsed ? "text-center" : "text-left"}`}>Main</div> */}
                <input
                  style={{
                    width: "100%",
                    minWidth: "200px",
                    border: "0px",
                    padding: "6px 10px",
                    outline: "none",
                    backgroundColor: "#F8F9FA",
                  }}
                  type="text"
                  value={search}
                  onChange={(e) => setSearch(e.target.value.trimStart())}
                  placeholder="Search..."
                  aria-label="Search..."
                  aria-describedby="basic-addon1"
                />
                <Menu menuItemStyles={menuItemStyles} transitionDuration={750}>
                  {search === "" ? (
                    <>
                      {sidebarData?.map((side) => {
                        const { menu, sub_menu, icon, link, permissions, key } = side;
                        const showMenu = permissions?.some((element) => permissionApi?.indexOf(element) !== -1);

                        return (showMenu || isSuperuser) && sub_menu ? (
                          <SubMenu
                            key={menu}
                            label={menu}
                            icon={icon}
                            onClick={() => handleOpenSubMenu(key)}
                            open={open === key}
                          >
                            {sub_menu.map((sub) => {
                              const { link, name, permissions } = sub;
                              const showMenu = permissions?.some((element) => permissionApi?.indexOf(element) !== -1);
                              return showMenu || isSuperuser ? (
                                <MenuItem
                                  active={location?.pathname === link}
                                  component={<Link to={link} />}
                                  key={name}
                                >
                                  {name}
                                </MenuItem>
                              ) : null;
                            })}
                          </SubMenu>
                        ) : showMenu || isSuperuser ? (
                          <MenuItem
                            active={location?.pathname === link}
                            component={<Link to={link} />}
                            key={menu}
                            icon={icon}
                          >
                            {menu}
                          </MenuItem>
                        ) : null;
                      })}
                    </>
                  ) : (
                    <>
                      {sidebarData?.map((side) => {
                        const { menu, sub_menu, icon, link, permissions, key } = side;
                        const showMenu = permissions?.some((element) => permissionApi?.indexOf(element) !== -1);
                        if (sub_menu?.length > 0) {
                          return (
                            <React.Fragment key={menu}>
                              {sub_menu?.some((menu) => menu.name.toLowerCase().includes(search.toLowerCase())) &&
                                (showMenu || isSuperuser) && (
                                  <>
                                    <SubMenu
                                      key={menu}
                                      label={menu}
                                      icon={icon}
                                      onClick={() => handleOpenSubMenu(key)}
                                      open={
                                        open === key ||
                                        sub_menu?.some((menu) => menu.name.toLowerCase().includes(search.toLowerCase()))
                                      }
                                    >
                                      {sub_menu?.map((sub) => {
                                        const { link, name, permissions } = sub;
                                        const showMenu = permissions?.some(
                                          (element) => permissionApi?.indexOf(element) !== -1
                                        );
                                        return name.toLowerCase().includes(search.toLowerCase()) &&
                                          (showMenu || isSuperuser) ? (
                                          <MenuItem
                                            active={location?.pathname === link}
                                            component={<Link to={link} />}
                                            key={name}
                                          >
                                            {name}
                                          </MenuItem>
                                        ) : null;
                                      })}
                                    </SubMenu>
                                  </>
                                )}
                            </React.Fragment>
                          );
                        } else {
                          return (
                            <React.Fragment key={menu}>
                              {menu.toLowerCase().includes(search.toLowerCase()) && (showMenu || isSuperuser) && (
                                <MenuItem
                                  active={location?.pathname === link}
                                  component={<Link to={link} />}
                                  key={menu}
                                  icon={icon}
                                >
                                  {menu}
                                </MenuItem>
                              )}
                            </React.Fragment>
                          );
                        }
                      })}
                    </>
                  )}
                </Menu>
              </div>

              <div>
                <div className={`sidebar-section-title ${collapsed ? "text-center" : "text-left"}`}>Setup</div>

                <Menu menuItemStyles={menuItemStyles} onClick={handleMenuClick} transitionDuration={750}>
                  {admin?.map((side, i) => {
                    const { menu, sub_menu, icon, link, permissions } = side;
                    const showMenu = permissions?.some((element) => permissionApi?.indexOf(element) !== -1);
                    return (
                      <div key={i}>
                        <>
                          {(showMenu || isSuperuser) && sub_menu ? (
                            <>
                              {
                                <SubMenu
                                  onClick={() => handleOpenSubMenu("setting")}
                                  open={open === "setting"}
                                  key={i + 1}
                                  label={menu}
                                  icon={icon}
                                >
                                  {sub_menu.map((sub, j) => {
                                    const { link, name, permissions, child_menu, key } = sub;
                                    const showSubMenu = permissions?.some(
                                      (element) => permissionApi?.indexOf(element) !== -1
                                    );
                                    const settingPermission = showSubMenu || isSuperuser;
                                    return child_menu
                                      ? settingPermission && (
                                          <SubMenu
                                            onClick={() => handleChildMenuOpen(key)}
                                            open={childMenuOpen === key}
                                            label={name}
                                            key={j + 1}
                                          >
                                            {child_menu.map((child, k) => {
                                              const { link, name, permissions } = child;
                                              const showChildMenu = permissions?.some(
                                                (element) => permissionApi?.indexOf(element) !== -1
                                              );
                                              return showChildMenu || isSuperuser ? (
                                                <MenuItem
                                                  active={location?.pathname === link}
                                                  component={<Link to={link} />}
                                                  key={k}
                                                >
                                                  {name}
                                                </MenuItem>
                                              ) : null;
                                            })}
                                          </SubMenu>
                                        )
                                      : settingPermission && (
                                          <MenuItem
                                            active={location?.pathname === link}
                                            component={<Link to={link} />}
                                            key={j + 1}
                                          >
                                            {name}
                                          </MenuItem>
                                        );
                                  })}
                                </SubMenu>
                              }
                            </>
                          ) : showMenu || isSuperuser ? (
                            <MenuItem
                              active={location?.pathname === link}
                              component={<Link to={link} />}
                              key={menu}
                              icon={icon}
                            >
                              {menu}
                            </MenuItem>
                          ) : null}
                        </>
                      </div>
                    );
                  })}
                </Menu>

                <Menu menuItemStyles={menuItemStyles} onClick={handleMenuClick} transitionDuration={750}>
                  <SubMenu
                    onClick={() => handleOpenSubMenu("user")}
                    open={open === "user"}
                    label={capitalizedUserName}
                    icon={photo ? <img src={photo} height={20} /> : ""}
                  >
                    <MenuItem
                      style={{
                        pointerEvents: disablePointerEvents ? "none" : "auto",
                      }}
                      active={location?.pathname === "/change-password"}
                      onClick={() => history.push("/change-password")}
                    >
                      Change Password
                    </MenuItem>
                    <MenuItem
                      style={{
                        pointerEvents: disablePointerEvents ? "none" : "auto",
                      }}
                      onClick={() => handleLogout()}
                    >
                      Logout
                    </MenuItem>
                  </SubMenu>
                </Menu>
              </div>
            </div>
          </Sidebar>
        )}
      </div>
      {showAlert && <CreateAlert showAlert={showAlert} setShowAlert={setShowAlert} setSubmit={setRemove} />}
    </>
  );
};

export default CrmSidebar;
